// Modules
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import {
  SendToInbox
} from 'components/models/triage/triage-items/triage-options';
import EmailMeta from 'components/models/email/emailMeta';
import Person from 'services/data/person';
import PersonLink from 'components/models/person/person-link';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

// Hooks
import { useTriageMutation } from 'modules/triage/hooks/useTriageMutation';

import { Claim, EmailDetails } from './triage-options';
import TriageItem from './triage-item';


export default function EmailItem({ item: email, currentUser, onDashboard, ...passed }) {
  const { update, claim } = useTriageMutation({ type: 'email', currentUser });

  const { recipientType, isPossibleMailgun, spamScore } = email;
  const archived = email.status === 'Archived';
  const fromPerson = !_.isEmpty(email.fromPerson) && email.fromPerson;
  const replyUser = !_.isEmpty(email.replyUser) && email.replyUser;
  const claimed = !_.isEmpty(email.claimedBy);
  const isSpam = spamScore > 5;

  const origin = (
    <Tooltip className="meta-tooltip" placement="bottom" title={<EmailMeta email={email} />}>
      <span className="truncate">
        { fromPerson && !onDashboard && <PersonLink person={fromPerson} /> }
        { fromPerson && onDashboard && Person.fullName(fromPerson) }
        { !fromPerson && (email.parsedFrom.name || email.parsedFrom.address) }
      </span>
      { !onDashboard && <SVG src="svg/info.svg" /> }
    </Tooltip>
  );

  const responseModifier = replyUser ? '(Responded) ' : null;
  const copiedModifier = recipientType === 'Copied' ? '(CC) ' : null;
  const modifier = responseModifier || copiedModifier || '';

  return (
    <TriageItem
      {...passed}
      itemOrigin={origin}
      payloadOrStatus={`${modifier}${email.subject}`}
      currentUser={currentUser}
      updateTriageItem={update}
      triageItem={email}
      onDashboard={onDashboard}
    >
      <EmailDetails email={email} />
      { isSpam &&
        <div className="bg-danger text-white d-flex align-items-center justify-content-between px-3 py-2">
          <span>Likely Spam!</span>
          <SVG src="svg/warning.svg" />
        </div>
      }
      <div className="triage-primary-options">
        { !claimed && <Claim triageItem={email} claim={claim} /> }
        {!archived && <SendToInbox confirm={isPossibleMailgun} emailId={email.id} currentUser={currentUser} /> }
      </div>
    </TriageItem>
  );
}

EmailItem.propTypes = {
  item: PropTypes.shape({
    open: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]),
    setOpen: PropTypes.func
  }),
  currentUser: PropTypes.object.isRequired,
  onDashboard: PropTypes.bool
};
